export default __webpack_public_path__ + "static/media/plusButtonBig.9e438dfa.svg";